﻿import $ from "jquery";

if ($.Color) {
	$.Color.fn.contrast = function () {
		var r = this._rgba[0], g = this._rgba[1], b = this._rgba[2];
		var d = (1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255) < 0.5 ? "0" : "F";
		return "#" + d + d + d;
	};
}

var autoColorLabel = "a";

$.fn.colorpicker = function (options) {

	var namedColors = { aliceblue: "#F0F8FF", antiquewhite: "#FAEBD7", aqua: "#00FFFF", aquamarine: "#7FFFD4", azure: "#F0FFFF", beige: "#F5F5DC", bisque: "#FFE4C4", black: "#000000", blanchedalmond: "#FFEBCD", blue: "#0000FF", blueviolet: "#8A2BE2", brown: "#A52A2A", burlywood: "#DEB887", cadetblue: "#5F9EA0", chartreuse: "#7FFF00", chocolate: "#D2691E", coral: "#FF7F50", cornflowerblue: "#6495ED", cornsilk: "#FFF8DC", crimson: "#DC143C", cyan: "#00FFFF", darkblue: "#00008B", darkcyan: "#008B8B", darkgoldenrod: "#B8860B", darkgray: "#A9A9A9", darkgrey: "#A9A9A9", darkgreen: "#006400", darkkhaki: "#BDB76B", darkmagenta: "#8B008B", darkolivegreen: "#556B2F", darkorange: "#FF8C00", darkorchid: "#9932CC", darkred: "#8B0000", darksalmon: "#E9967A", darkseagreen: "#8FBC8F", darkslateblue: "#483D8B", darkslategray: "#2F4F4F", darkslategrey: "#2F4F4F", darkturquoise: "#00CED1", darkviolet: "#9400D3", deeppink: "#FF1493", deepskyblue: "#00BFFF", dimgray: "#696969", dimgrey: "#696969", dodgerblue: "#1E90FF", firebrick: "#B22222", floralwhite: "#FFFAF0", forestgreen: "#228B22", fuchsia: "#FF00FF", gainsboro: "#DCDCDC", ghostwhite: "#F8F8FF", gold: "#FFD700", goldenrod: "#DAA520", gray: "#808080", grey: "#808080", green: "#008000", greenyellow: "#ADFF2F", honeydew: "#F0FFF0", hotpink: "#FF69B4", indianred: "#CD5C5C", indigo: "#4B0082", ivory: "#FFFFF0", khaki: "#F0E68C", lavender: "#E6E6FA", lavenderblush: "#FFF0F5", lawngreen: "#7CFC00", lemonchiffon: "#FFFACD", lightblue: "#ADD8E6", lightcoral: "#F08080", lightcyan: "#E0FFFF", lightgoldenrodyellow: "#FAFAD2", lightgray: "#D3D3D3", lightgrey: "#D3D3D3", lightgreen: "#90EE90", lightpink: "#FFB6C1", lightsalmon: "#FFA07A", lightseagreen: "#20B2AA", lightskyblue: "#87CEFA", lightslategray: "#778899", lightslategrey: "#778899", lightsteelblue: "#B0C4DE", lightyellow: "#FFFFE0", lime: "#00FF00", limegreen: "#32CD32", linen: "#FAF0E6", magenta: "#FF00FF", maroon: "#800000", mediumaquamarine: "#66CDAA", mediumblue: "#0000CD", mediumorchid: "#BA55D3", mediumpurple: "#9370D8", mediumseagreen: "#3CB371", mediumslateblue: "#7B68EE", mediumspringgreen: "#00FA9A", mediumturquoise: "#48D1CC", mediumvioletred: "#C71585", midnightblue: "#191970", mintcream: "#F5FFFA", mistyrose: "#FFE4E1", moccasin: "#FFE4B5", navajowhite: "#FFDEAD", navy: "#000080", oldlace: "#FDF5E6", olive: "#808000", olivedrab: "#6B8E23", orange: "#FFA500", orangered: "#FF4500", orchid: "#DA70D6", palegoldenrod: "#EEE8AA", palegreen: "#98FB98", paleturquoise: "#AFEEEE", palevioletred: "#D87093", papayawhip: "#FFEFD5", peachpuff: "#FFDAB9", peru: "#CD853F", pink: "#FFC0CB", plum: "#DDA0DD", powderblue: "#B0E0E6", purple: "#800080", red: "#FF0000", rosybrown: "#BC8F8F", royalblue: "#4169E1", saddlebrown: "#8B4513", salmon: "#FA8072", sandybrown: "#F4A460", seagreen: "#2E8B57", seashell: "#FFF5EE", sienna: "#A0522D", silver: "#C0C0C0", skyblue: "#87CEEB", slateblue: "#6A5ACD", slategray: "#708090", slategrey: "#708090", snow: "#FFFAFA", springgreen: "#00FF7F", steelblue: "#4682B4", tan: "#D2B48C", teal: "#008080", thistle: "#D8BFD8", tomato: "#FF6347", turquoise: "#40E0D0", violet: "#EE82EE", wheat: "#F5DEB3", white: "#FFFFFF", whitesmoke: "#F5F5F5", yellow: "#FFFF00", yellowgreen: "#9ACD32" };
	var defaultColors = ["#FFFFFF", "#FFCCCC", "#FFCC99", "#FFFF99", "#FFFFCC", "#99FF99", "#99FFFF", "#CCFFFF", "#CCCCFF", "#FFCCFF", "#DDDDDD", "#FF6666", "#FF9966", "#FFFF66", "#FFFF33", "#66FF99", "#33FFFF", "#66FFFF", "#9999FF", "#FF99FF", "#BBBBBB", "#FF0000", "#FF9900", "#FFCC66", "#FFFF00", "#33FF33", "#66CCCC", "#33CCFF", "#6666CC", "#CC66CC", "#999999", "#CC0000", "#FF6600", "#FFCC33", "#FFCC00", "#33CC00", "#00CCCC", "#3366FF", "#6633FF", "#CC33CC", "#666666", "#990000", "#CC6600", "#CC9933", "#999900", "#009900", "#339999", "#3333FF", "#6600CC", "#993399", "#333333", "#660000", "#993300", "#996633", "#666600", "#006600", "#336666", "#000099", "#333399", "#663366", "#000000", "#330000", "#663300", "#663333", "#333300", "#003300", "#003333", "#000066", "#330099", "#330033"];

	function show() {
		/* jshint validthis: true */
		var cp = $(this);
		if(cp.data("popup") != null) {
			$(cp.data("popup")).remove();
			cp.removeData("popup");
			return;
		}
		this.focus();
		var options = cp.data("options");
		var id = "popup_" + Math.random().toString(32).substring(2);
		cp.data("popup", "#" + id);
		var value = $(cp.data("for")).val();
		if(value.charAt(0) != "#") {
			value = namedColors[value];
		}
		var container = $("<div>", { id: id, "class": "ui-popup" }).on("mousedown", cp.data(), select);
		var tbody = $("<tbody>");
		var tr = null;
		for(var i = 0; i < defaultColors.length; i++) {
			var cc = defaultColors[i];
			if((i % 10) === 0) {
				tr = $("<tr>").appendTo(tbody);
			}
			var a = $("<a>", { href: cc, title: cc, "class": (value == cc) ? "ui-selected" : null }).css({ "background-color": cc });
			if(options.textColor) {
				var color = options.textColor;
				if(color == "auto")
					color = $.Color(cc).contrast();
				a.css("color", color).text(autoColorLabel);
			}
			$("<td>").append(a).appendTo(tr);
		}
		container.append($("<table class=\"ui-colorpicker\">").append(tbody)).appendTo(document.body);
		container.show().position({ my: "right top", at: "right bottom", of: cp }).on("click", function(e) {
			e.stopPropagation();
		});
	}

	function hide(e) {
		var ee = $(e.target);
		var id = ee.data("popup");
		window.setTimeout(function() {
			$(id).remove();
			ee.removeData("popup");
		}, 100);
	}

	function select(e) {
		var ee = $(e.target);
		if(ee.is("A")) {
			$(e.data["for"]).val(ee.attr("href")).trigger("change");
			ee.trigger("focus");
		}
		e.stopPropagation();
		e.preventDefault();
	}

	function sync(e) {
		var ee = $(e.target);
		var value = ee.val().trim();
		if(value !== "") {
			if(!/^#[0-9A-F]{6}$/i.test(value) && namedColors[value.toLowerCase()] == null)
				value = "";
		}
		setUI($(ee.data("colorButton")), value);
	}

	function setUI(b, value) {
		var e = $("span.ui-colorbox", b);
		var options = b.data("options");
		e.css({ "background": value });
		if(options.textColor != null && value !== "") {
			e.css("color", options.textColor == "auto" ? $.Color(value).contrast() : options.textColor)
			.text(autoColorLabel);
		}
		else {
			e.css("color", null).text("\xA0");
		}
		return b;
	}

	function init() {
		/* jshint validthis: true */
		var e = $(this).uniqueId().addClass("ui-split");
		var cid = e.attr("id");
		var value = e.val();
		var b = $("<button>", { type: "button", "class": "ui-button ui-split ui-colorpicker-trigger" })
			.data("for", "#" + cid)
			.data("options", $.extend({ textColor: e.data("textColor") }, options))
			.append($("<span>", { "class": "ui-colorbox" }))
			.on("click", show)
			.on("blur", hide)
			.uniqueId();
		setUI(b, value);
		e.after(b)
		.data("colorButton", "#" + b.attr("id"))
		.on("change", sync);
	}

	return this.each(init);
};
